import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MatPaginatorIntlProvider extends MatPaginatorIntl {

    constructor(private translateService: TranslateService) {
        super();

        this.translateService.onLangChange.subscribe((e: Event) => {
            this.initializeTranslations();
        });
    }

    getRangeLabel = function (page, pageSize, length) {
        if (length === 0 || pageSize === 0) {
            if (this.translateService && this.translateService.currentLang) {
                return this.translateService.instant('PAGINATOR.CURRENT_ITEM_OF', { countOfItems: length });
            } else {
                return '0 of ' + length;
            }
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;

        if (this.translateService && this.translateService.currentLang) {
            return this.translateService.instant('PAGINATOR.CURRENT_ITEM_OF_PAGE', { firstItemIndex: startIndex + 1, lastItemIndex: endIndex, countOfItems: length });
        } else {
            return startIndex + 1 + ' - ' + endIndex + ' of ' + length;
        }
    };

    private initializeTranslations(): void {
        this.itemsPerPageLabel = this.translateService.instant('PAGINATOR.ITEMS_PER_PAGE');
        this.nextPageLabel = this.translateService.instant('PAGINATOR.NEXT_PAGE');
        this.previousPageLabel = this.translateService.instant('PAGINATOR.PREVIOUS_PAGE');
        this.firstPageLabel = this.translateService.instant('PAGINATOR.FIRST_PAGE');
        this.lastPageLabel = this.translateService.instant('PAGINATOR.LAST_PAGE');
    }

}